import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { NetworkService } from '../../service/network.service';
import { GenericAkitaHTTPService, HttpOptions } from '../../service/generic-akita-http.service';
import { EmergencyVehicle } from '../../model/emergency-vehicle';
import { subDays } from 'date-fns';

@Injectable({
  providedIn: 'root'
})
export class AkitaVehicleHttpService extends GenericAkitaHTTPService<EmergencyVehicle> {
  constructor(http: HttpClient, networkService: NetworkService) {

    const options: HttpOptions = {
      params: {
        type: 'EmergencyVehicle',
        options: 'keyValues',
        attrs: '*,dateModified',
        limit: '50'
      }
    };
    super(http, networkService, '/v2/entities/', 'EmergencyVehicle', options);
  }
}

